import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";

const DeleteMeasureModal = ({ isOpen, isDeleting, onCancel, onConfirm, t }) => {
    const close = () => {
        if (!isDeleting) {
            onCancel();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={close}>
            <ModalHeader toggle={close}>
                {t("Delete measure?")}
            </ModalHeader>
            <ModalBody>
                <p className="mb-0">
                    {t("Are you sure you want to delete this measure?")}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" disabled={isDeleting} onClick={close}>
                    {t("Cancel")}
                </Button>
                <Button color="danger" disabled={isDeleting} onClick={onConfirm}>
                    {isDeleting && (
                        <Spinner size="sm" className="me-1" />
                    )}
                    {t("Delete")}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteMeasureModal;
